import { FC, ReactElement } from 'react'

import { SpinnerGapIcon } from '@phosphor-icons/react'
import { Slot, Slottable } from '@radix-ui/react-slot'

import { Text } from '../Text'
import { buttonVariants, iconVariants, spinnerVariants } from './styles'
import { ButtonProps } from './types'

export const Button: FC<ButtonProps> = (props): ReactElement => {
  const {
    asChild = false,
    children,
    className,
    color,
    disabled = false,
    iconLeft: IconLeft,
    iconLeftWeight = 'regular',
    iconRight: IconRight,
    iconRightWeight = 'regular',
    isLoading = false,
    isDashed = false,
    isRounded = false,
    textOnLoading,
    type = 'button',
    variant,
    withLoadingText = true,
    ...rest
  } = props

  const Component = asChild ? Slot : 'button'

  return isLoading ? (
    <button className={buttonVariants({ color, className, isDashed, isRounded, variant })} disabled type="button">
      <SpinnerGapIcon className={spinnerVariants({ color, variant })} />

      {withLoadingText && <Text className="font-body text-sm leading-none">{textOnLoading ?? 'Carregando'}</Text>}
    </button>
  ) : (
    <Component
      className={buttonVariants({ color, className, isDashed, isRounded, variant })}
      disabled={disabled || isLoading}
      type={type}
      {...rest}
    >
      {IconLeft && <IconLeft size={16} weight={iconLeftWeight} className={iconVariants({ color, variant })} />}
      <Slottable>{children}</Slottable>
      {IconRight && <IconRight size={16} weight={iconRightWeight} className={iconVariants({ color, variant })} />}
    </Component>
  )
}
